import DialogDefault from 'core/modules/components/dialogs/components/Dialog';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import DiagramMermaid from '../DiagramMermaid/DiagramMermaid';
import './ChatMermaidModal.scss';

function ChatMermaidModal({ conversationId, isOpen, mermaidCode, messageId, onClose, t, title }) {
  return (
    <DialogDefault open={isOpen} onClose={onClose} title={title || t('chatbot:Diagram')} size="xxl" hideHeader={false} separator>
      <div className="chat-mermaid-modal-container">
        {isOpen && mermaidCode && (
          <DiagramMermaid
            className="chat-mermaid-modal__diagram"
            config={{ legacyMathML: true }}
            conversationId={conversationId}
            mermaidCode={mermaidCode}
            messageId={messageId}
            t={t}
          />
        )}
      </div>
    </DialogDefault>
  );
}

ChatMermaidModal.propTypes = {
  conversationId: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  mermaidCode: PropTypes.string,
  messageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ChatMermaidModal.defaultProps = {
  conversationId: null,
  mermaidCode: '',
  messageId: null,
  title: '',
};

export default withTranslation(['chatbot'])(ChatMermaidModal);
